import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  archive(event) {
    event.preventDefault();
    App.Helpers.ajaxRequest({url: this.url, method: "PUT", successHandler: this.emitArchiveCompleteEvent.bind(this)})
  }

  emitArchiveCompleteEvent(response) {
    document.dispatchEvent(createCustomEvent(this.completeEventName, this.element, {response}));
  }

  //
  // GETTERS AND SETTERS
  //

  get url() {
    return this.data.get("url");
  }
};



// WEBPACK FOOTER //
// ./app/components/notifications/assets/javascript/notifications-archive-action-controller-base.js